/* eslint-disable */
<template>
    <div id="Wesenstest">
        <div id="Start" v-if="state==0">
            <h3>Kommunikationstypen Test</h3>
            <br>
            <p> Finden Sie heraus welcher Kommunikations-Typ sie sind.</p>

            <b-button
                id="StartButton"
                v-on:click="start">
                Start
            </b-button>
        </div>

        <div id="Selection" v-if="state==1">
            <h3>Am ehesten bin ich...</h3>
            <br>
            <b-button
                v-for="type in buttonType"
                :class="{active: type === selected }"
                id="SelectionButton"
                v-on:click="answer(type)">
                {{getText(type)}}
            </b-button>
            <br>
            <b-button
                id="SelectionButton"
                variant="info"
                v-on:click="next()">
                Weiter
            </b-button>
        <br>
        {{currentSelection+1}}/{{combinedSelectones}}
        </div>
        <div id="Results" v-if="state==2">
            <b-card
                header="Auswertung"
                tag="article"
                id="cards"
                class="mb-2">
                <h4 class="card-title">
                    Ihr Kommunikations-Typ entspricht {{primaryCardText[0][primeryResult]}}
                </h4>
                <img
                    style="width:100%;"
                    :src="typeImages[primeryResult]">
                <p class="card-text">
                    <h3>{{primaryCardText[1][primeryResult]}}</h3>
                </p>
                <h3>Meine Anteile:</h3>
                <p class="card-text">
                    <h3>Berg: {{selectiones[0]}}</h3>
                    <h3>See: {{selectiones[1]}}</h3>
                    <h3>Wald: {{selectiones[2]}}</h3>
                    <h3>Wiese: {{selectiones[3]}}</h3>
                </p>
            </b-card>

            <b-card
                header="Erklärung"
                tag="article"
                id="cards"
                class="mb-2">

                <p>
                    Probleme mit anderen oder gar mit sich selbst, entstehen oft durch eine missverständliche oder fehlerhafte Kommunikation. 
                    Wenn man versteht, wie man selbst tickt, hat man es leichter mit sich selbst – weil man weiß, was man selbst braucht und wie man sich selbst motivieren kann. 
                    Wer herausfindet wie andere ticken, kann ganz einfach mit jedem kommunizieren und herausfinden, wie man z. B. Kontakt aufnimmt, wie man andere begeistert, was andere einschüchtert oder gar ablehnen. 
                    Missverständnisse können vermieden werden und der Kontakt kann verbessert werden. 
                    Jeder Mensch vereint verschiedene Persönlichkeitsanteile in sich. Das Verhältnis der Anzahl der jeweiligen Anteile sagt viel darüber aus, wie Kommunikation gelingen kann. 
                </p>

                <h4>Bedeutung der verschiedenen Anteile</h4>


                <h5>Berg:</h5>
                <p>
                    Die Berg-Anteile sorgen dafür, dass man was verändern und erreichen möchte. 
                    Sie lassen uns gerne die Führung übernehmen. 
                </p>

                <h5>See: </h5>
                <p>
                    Die See-Anteile wollen auf die Bühne! 
                    Hier liegen Verkaufstalente und Schauspielkünste.
                </p>

                <h5>Wald:</h5>
                <p>
                    Die Wald-Anteile sorgen für Zuverlässigkeit. 
                    Wer Ordnung und Struktur liebt, hat meist viele von ihnen. 
                </p>

                <h5>Wiese:</h5>
                <p>
                    Die Wiesen-Anteile lieben die Leichtigkeit und brauchen einen geschützten Ort. 
                    Menschen in Sozialberufen tragen viele in sich.
                </p>

                <h4>Bedeutung der Mischformen</h4>

                <h5>Berg- & See-Anteile:</h5>
                <p>
                    Ich brauche den Überblick und langweile mich bei Details. 
                    Ich präsentiere mich gerne und kann gut auf andere zugehen.
                </p>

                <h5>Wald- & Wiesen-Anteile:</h5>
                <p>
                    Ich mag Details und brauche Informationen dazu. 
                    Ich halte mich etwas zurück und überlasse gerne anderen die Bühne.
                </p>

                <h5>See- & Wiesen-Anteile:</h5>
                <p>
                    Ich brauche Menschen um mich. 
                    Ich helfe ihnen gerne und arbeite gerne mit anderen zusammen. 
                </p>

                <h5>Berg- & Wald-Anteile:</h5>
                <p>
                    Ich bin eher sachlich und mag Aufgaben, die mich Herausfordern. 
                    Menschen müssen nicht ständig in meiner Nähe sein.
                </p>

                <h4>Überkreuz-Formen</h4>
                <p>
                    Überkreuz-Formen, wie eine fast gleichhohe Anzahl an See-Wald-Anteilen kennt man zum Beispiel von perfektionistischen Musikern. 
                    Berg-Wiesen-Anteils-Überkreuzformen kommen auch eher selten vor und zeigen sehr ausgeglichene Führungspersönlichkeiten. 
                </p>
                <p>
                    Weitere Infos zu den 4 Kommunikationstypen, was ihnen guttut, wie man mit ihnen umgeht, was passieren kann, wenn es ihnen nicht gut geht und wie man herausfindet, dass es ihnen gut geht erhält man in den Coachings und Beratungen im <br>
                    <a href="www.fritschamberg.at ">****MentalSpa-Resort Fritsch am Berg. </a> 
                </p> 
            </b-card>

             

            <br>
            <b-button
                style="width:250px;margin-top:10px;"
                id="ResultButton"
                v-on:click="reset()">
                Reset
            </b-button>
            <br>
            <b-button
                style="width:250px;margin-top:10px;margin-bottom:20px;"
                id="ResultButton"
                v-on:click="toWebsite()">
                Zur Website
            </b-button>

        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {
            state:0,
            currentSelection:0,
            combinedSelectones:20,
            selected:false,
            selectiones:[0,0,0,0],
            types:['Berg','See','Wald','Wiese'],
            typeImages:[
                require('../assets/images/berg.jpg'),
                require('../assets/images/see.jpg'),
                require('../assets/images/wald.jpg'),
                require('../assets/images/wiese.jpg')
            ],
            shuffledArray: this.getShuffeldArray(20),
            primaryCardText:[
                [
                    'dem Berg',
                    'dem See',
                    'dem Wald',
                    'der Wiese'
                ],
                [
                    'Sie sind ein Macher, \n zielstrebig & selbstbewusst!',
                    'Sie sind ein Unterhalter, \n erfrischend & vielseitig',
                    'Sie sind der Zuverlässige, \n analytisch & achtsam ',
                    'Sie sind der Fürsorgliche, \n hilfsbereit & geduldig'
                ]
            ],
            buttonType: this.getShuffeldArray(4),
            optionesBerg:[
                'praktisch',
                'ausdauernd',
                'konsequent',
                'selbstbewußt',
                'visionär',
                'willensstark',
                'wagemutig',
                'forsch',
                'entscheidungsfreudig',
                'zielorientiert',
                'beherrschend',
                'konfliktfreudig',
                'hitzig',
                'reizbar',
                'aggressiv',
                'eigensinnig',
                'ungeduldig',
                'dickköpfig',
                'dominierend',
                'intolerant',
            ],
            optionesSee:[
                'erfrischend',
                'fröhlich',
                'lebhaft',
                'gesellig',
                'überzeugend ',
                'emotional',
                'beliebt',
                'spontan',
                'optimistisch',
                'positiv',
                'unorganisiert',
                'unbedacht',
                'unruhig',
                'undiszipliniert',
                'oberflächlich',
                'rastlos',
                'zerstreut',
                'impulsiv',
                'willensschwach',
                'egoistisch',
            ],
            optionesWald:[
                'analytisch',
                'detailliert',
                'tiefgründig',
                'rücksichtsvoll',
                'vorausplanend',
                'loyal',
                'gefühlvoll',
                'nachdenklich',
                'organisiert',
                'genau',
                'zweifelnd',
                'misstrauisch',
                'einzelgängerisch',
                'pessimistisch',
                'skeptisch',
                'sensibel',
                'unsicher',
                'kritisch',
                'aufopfernd',
                'verschlossen',
            ],
            optionesWiese:[
                'beherrscht',
                'zufrieden',
                'freundlich',
                'motivierend',
                'anpassungsfähig',
                'genügsam',
                'friedlich',
                'geduldig',
                'verbindlich',
                'zuverlässig',
                'unentschlossen',
                'konfliktscheu',
                'selbstlos',
                'ängstlich',
                'unbeteiligt',
                'träge',
                'zögernd',
                'zaghaft',
                'schwach',
                'reserviert',
            ],
        }
    },
    methods: {
        scrollToTop() {
                window.scrollTo(0,0);
        },
        start(){
            this.state = 1;
            this.scrollToTop()
            this.height = "100";
        },
        answer(selection){
            this.selected = selection;
        },
        next(){
            this.scrollToTop()
            if(this.selected !== false){
                this.selectiones[this.selected] +=1;
                this.currentSelection +=1;
                this.selected = false;
                this.shuffleArray(this.buttonType);
                if(this.currentSelection == this.combinedSelectones){
                    this.state = 2;
                }
            }
        },
        reset(){
            this.state = 0;
            this.selected = false;
            this.currentSelection =0;
            this.currentSelection = 0;
            this.selectiones = [0,0,0,0];
            this.getShuffeldArray(combinedSelectones);
        },
        toWebsite(){
            var win = window.open('http://www.fritschamberg.at/de/arrangements/', '_blank');
            win.focus();
        },
        secondMax(arr){
            var max = Math.max.apply(null, arr), // get the max of the array
            maxi = arr.indexOf(max);
            arr[maxi] = -Infinity; // replace max in the array with -infinity
            var secondMax = Math.max.apply(null, arr); // get the new max
            arr[maxi] = max;
            return secondMax;
        },
        shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        },
        getShuffeldArray(len){
            let a = this.shuffleArray([...Array(len).keys()]);
            console.log(a);
            return a;
        },
        getText(type) {
            switch(type) {
                case 0:
                    return this.optionesBerg[this.shuffledArray[this.currentSelection]];
                break;
                case 1:
                    return this.optionesSee[this.shuffledArray[this.currentSelection]];
                break;
                case 2:
                    return this.optionesWald[this.shuffledArray[this.currentSelection]];
                break;
                case 3:
                    return this.optionesWiese[this.shuffledArray[this.currentSelection]];
                break;
            }
        },
    },
    computed: {
        primeryResult(){
            return this.selectiones.indexOf(Math.max(...this.selectiones));
        },
        secondaryResult(){
            var tempSelectiones =   this.selectiones.slice();
            var temptypes =         this.types.slice();
            return 3-tempSelectiones.reverse().indexOf(this.secondMax(this.selectiones));
        }
    }

}
</script>
